module.exports = __webpack_public_path__ + "assets/5e602f8a-1e6a-461e-bfd8-ff46a5460527.e605451d.svg";